<template>
	<c-dialog ref="dialog" height="380" width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="核销单号">
				<span class="audit-order-info">{{checkOrderData.record_number}}</span>
			</c-form-item>
			<c-form-item label="核销金额">
				<span class="audit-order-info">￥{{checkOrderData.settlement_amount || '0.00'}}</span>
			</c-form-item>
			<c-form-item label="审核结果" required>
				<c-radio-group name="check_status" :options="checkStatusDic" v-model="checkStatus"></c-radio-group>
			</c-form-item>
			<c-form-item label="驳回原因" required v-show="checkStatus == 3" tip="驳回后核销单将变更为“审核驳回”状态，可删除核销单后重新生成核销数据">
				<c-input type="textarea" name="reject_reason" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
    name: 'orderCheckAudit',

	components: {
	},

	data() {
		return {
			//审核结果选项：1-审核通过（状态变更为：已核销（审核通过））  3-审核驳回（状态变更为：审核驳回）
			checkStatusDic: [
				{name: '审核通过', value: 1, color: 'blue'},
				{name: '审核驳回', value: 3, color: 'red'},
			],
			checkStatus: 1,           //审核结果（默认：审核通过）
			checkOrderData: {}        //待审核的核销单数据
		}
	},

	methods: {
		/*********打开审核弹窗，初始化**********/
        open(data) {
            this.checkOrderData = data || {};
            this.checkStatus = 1;
            this.$refs.form.clear();
            this.$refs.form.set({
            	check_status: this.checkStatus
            });
			this.$refs.dialog.open({
				title: '核销单审核'
			});
		},

		/*******审核提交处理方法（驳回必须填写驳回原因）********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/sale/check/audit',
				rule: {
                    check_status: '请选择审核结果',
                    reject_reason: [{
                        type: 'empty',
                        message: '请输入审核驳回原因',
                        skip: () => {
                            return this.checkStatus == 1;
                        }
                    }]
				},
				dataFormatter: data => {
					//接口参数：id-核销单ID  status-审核结果（1-通过 3-驳回）  reject_reason-驳回原因
                    data.id = this.checkOrderData.id;
                    data.status = this.checkStatus;
                    delete data.check_status;
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: this.checkStatus == 1 ? '审核通过，核销完成' : '审核驳回成功',
                        type: 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
.audit-order-info {
	font-weight: bold;
}
</style>
